
export default function WhoItsFor() {
  const audiences = [
    {
      icon: 'ri-run-line',
      label: 'Beginner Runners',
      color: 'bg-[#FFE5E5]'
    },
    {
      icon: 'ri-graduation-cap-line',
      label: 'High School Athletes',
      color: 'bg-[#E5F5E5]'
    },
    {
      icon: 'ri-user-smile-line',
      label: 'Recreational Runners',
      color: 'bg-[#FFF5E5]'
    },
    {
      icon: 'ri-trophy-line',
      label: 'Race Training',
      color: 'bg-[#E5F0FF]'
    },
    {
      icon: 'ri-calendar-check-line',
      label: 'Consistency Seekers',
      color: 'bg-[#F5E5FF]'
    }
  ];

  return (
    <section id="who-its-for" className="py-24 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <h2 className="text-4xl font-bold text-gray-900 mb-12">Who This Is For</h2>

        <div className="flex gap-6 overflow-x-auto pb-4 scrollbar-hide">
          {audiences.map((audience, index) => (
            <div
              key={index}
              className={`flex-shrink-0 w-64 ${audience.color} rounded-3xl p-8 hover:scale-105 hover:shadow-lg transition-all cursor-pointer`}
              style={{ marginLeft: index > 0 ? '-40px' : '0' }}
            >
              <div className="w-16 h-16 flex items-center justify-center mx-auto mb-6">
                <i className={`${audience.icon} text-5xl text-gray-800`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 text-center">{audience.label}</h3>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center max-w-3xl mx-auto">
          <p className="text-lg text-gray-600 leading-relaxed">
            Adults training for the <strong>800m up to the marathon</strong> — anyone wanting consistency, structure, and progress.
          </p>
        </div>
      </div>
    </section>
  );
}
